export default __webpack_public_path__ + "static/logo-rma-58e220a0afae6aa8f6db00a356f32775.png";